/**
 * toileSignInCard — Toile's own surface on the shared sign-in card (`@core/auth-ui/SignInCard`,
 * plan `2026_09_17_ovid_one_wall.md` § Decided 6). The stacked lockup, and the two pages this
 * house shelves its policy at. The card's own default copy and stylesheet are the ones Toile
 * shipped, so nothing else is stated here.
 */
import {ToileMark} from '@product/toile/components/ToileMark'

export const TOILE_SIGN_IN_CARD = {
    glyph: {mark: <ToileMark size={42} />, word: 'toile'},
    termsHref: '/terms',
    privacyHref: '/privacy',
}
